import { render, staticRenderFns } from "./basicMain.vue?vue&type=template&id=02722324&scoped=true&"
import script from "./basicMain.vue?vue&type=script&lang=js&"
export * from "./basicMain.vue?vue&type=script&lang=js&"
import style0 from "./basicMain.vue?vue&type=style&index=0&id=02722324&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02722324",
  null
  
)

export default component.exports